import { createAction, props } from '@ngrx/store';


export enum PermissionsActionTypes {
  LoadPermissions = '[Permission] Load Permissions',
  LoadPermissionsSuccess = '[Permission] Load Permissions Success'

}

export const LoadPermissions = createAction(PermissionsActionTypes.LoadPermissions);

export const LoadPermissionsSuccess = createAction(PermissionsActionTypes.LoadPermissionsSuccess,
  props<{ permission: any}>());

